export const NOT_FOUND_ERROR_CODE = "404";
